<template>
  <div v-if="isVisible" class="fields-extraction-progress">
    <div v-if="isQueued" class="fields-extraction-progress__step">
      <span class="icon">
        <BaseCircularLoadingBar :size="16" :width="2" />
      </span>
      <span>{{ $tc('documents-summary.extraction-steps.queued', queueAhead, { ahead: queueAhead }) }}</span>
    </div>
    <template v-else>
      <div v-for="(step, index) in displaySteps" :key="step.key" class="fields-extraction-progress__step">
        <span class="icon">
          <template v-if="index < currentStepIndex">
            <BaseIcon name="check-circle" class="fields-extraction-progress__step-completed-icon" />
          </template>
          <template v-else-if="index === currentStepIndex">
            <BaseCircularLoadingBar :size="16" :width="2" />
          </template>
          <template v-else>
            <span class="fields-extraction-progress__step-not-started-icon"></span>
          </template>
        </span>
        <span>{{ step.text }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseCircularLoadingBar from '@/components/base/BaseCircularLoadingBar.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { DISPLAY_STEPS, getDisplayStepIndex } from '@/models/extraction-steps';

export default {
  name: 'FieldsExtractionProgress',
  components: { BaseCircularLoadingBar, BaseIcon },
  props: {
    fieldId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('fieldsExtraction', [
      'isExtracting',
      'extractingFieldId',
      'currentStep',
      'isQueued',
      'queuePosition',
    ]),
    isTargeted() {
      if (!!this.fieldId) {
        return this.extractingFieldId === this.fieldId;
      }
      return !this.extractingFieldId;
    },
    isVisible() {
      return this.isExtracting && this.isTargeted;
    },
    displaySteps() {
      return DISPLAY_STEPS.map(({ displayKey }) => ({
        key: displayKey,
        text: this.$t(`documents-summary.extraction-steps.${displayKey}`),
      }));
    },
    queueAhead() {
      const pos = this.queuePosition && this.queuePosition.position;
      return pos != null && pos > 0 ? pos - 1 : 0;
    },
    currentStepIndex() {
      return getDisplayStepIndex(this.currentStep);
    },
  },
};
</script>

<style scoped lang="scss">
.fields-extraction-progress {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;

  &__step {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: $font-size-small;
    color: $color-neutral;

    &-not-started-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid $color-neutral;
    }

    &-completed-icon {
      width: 16px;
      color: $color-green;
    }
  }
}
</style>
